// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"548":"926c604f","677":"926c604f"}[chunkId] + ".chunk.css";
};